package com.milta.feature.subscription.data.remote.dto

import com.milta.feature.subscription.domain.entity.Subscription
import com.milta.feature.subscription.domain.entity.SubscriptionPlan
import com.milta.feature.subscription.domain.entity.SubscriptionStatus
import kotlinx.serialization.Serializable

@Serializable
data class SubscriptionDto(
    val plan: String,
    val status: String,
    // null on a Trial row — no store platform/product behind a free trial.
    val platform: String? = null,
    val storeProductId: String? = null,
    val expiresAt: String? = null,
)

fun SubscriptionDto.toDomain() = Subscription(
    plan = when (plan) {
        "Organisation" -> SubscriptionPlan.Organisation
        else -> SubscriptionPlan.Driver
    },
    status = when (status) {
        "GracePeriod" -> SubscriptionStatus.GracePeriod
        "Trial" -> SubscriptionStatus.Trial
        "Expired" -> SubscriptionStatus.Expired
        "Cancelled" -> SubscriptionStatus.Cancelled
        else -> SubscriptionStatus.Active
    },
    platform = platform,
    storeProductId = storeProductId,
    expiresAt = expiresAt,
)
